'use client';

import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

export default function CtaCentral() {
	const ref = useRef(null);
	const isInView = useInView(ref, { once: true, margin: '-100px' });

	const textVariants = {
		hidden: { opacity: 0, y: 50 },
		visible: { opacity: 1, y: 0 },
	};

	return (
		<section ref={ref} className="relative h-full flex items-center justify-center   px-6 md:px-14 overflow-hidden">
			{/* Painel escuro grande */}
			<div className="relative mx-auto w-full max-w-[100%] rounded-[32px] bg-[#0b1a36] text-white sm:px-8 md:px-16   sm:h-[85vh] flex items-center justify-center">
				<motion.p
					variants={textVariants}
					initial="hidden"
					animate={isInView ? 'visible' : 'hidden'}
					transition={{ duration: 0.8, delay: 0.2 }}
					className="text-3xl py-10 sm:text-4xl md:text-6xl lg:text-7xl  text-center leading-tight"
				>
					Encontre o imóvel perfeito para você.
				</motion.p>
			</div>
		</section>
	);
}
